import { FormEvent } from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { TLicensingAuthorityType } from '@/shared/models/licensingAuthority';
import { BottomButtons } from '@/shared/view/BottomButtons';
import { Section } from '@/shared/view/Section';
import { Selection } from '@/shared/view/Selection';
import { Button } from '@src-common/view/adapters/Button';

import s from './styles.module.css';

interface FormShape {
  licensingAuthority: TLicensingAuthorityType | 'None';
}

interface Item {
  value: FormShape['licensingAuthority'];
  title: string;
}

interface IProps {
  items: Item[];
  onSubmit: (e: FormEvent) => void;
  isSubmitting: boolean;
  isValid: boolean;
  control: Control<FormShape>;
}

const Form = ({ items, onSubmit, isSubmitting, isValid, control }: IProps) => (
  <form onSubmit={onSubmit}>
    <Section>
      <div className={s.items}>
        {items.map(item => (
          <Selection
            name="licensingAuthority"
            control={control}
            key={item.value}
            value={item.value}
            title={item.title}
            rules={{ required: true }}
          />
        ))}
      </div>
    </Section>
    <BottomButtons>
      <Button type="submit" isPending={isSubmitting} isDisabled={!isValid}>
        <FormattedMessage
          defaultMessage="NEXT"
          id="6jg2Fp"
          description="OnBoarding next button text"
        />
      </Button>
    </BottomButtons>
  </form>
);

export { Form };
export type { FormShape, Item };
